module.exports = __webpack_public_path__ + "static/media/FR.8d23b827.svg";